import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useListIntegrationsV2, IntegrationConfigAppModelV2, IntegrationAppModel } from '@api';

export function useRemappedIntegrations() {
  const { integrations, configs, isIntegrationsFetched } = useListIntegrationsV2();

  const remappedConfigs = configs.reduce<Record<string, IntegrationConfigAppModelV2>>((acc, config) => {
    acc[config.type] = config;
    return acc;
  }, {});

  const remappedIntegrations = integrations.reduce<
    Record<string, { integration: IntegrationAppModel; config: IntegrationConfigAppModelV2 }>
  >((acc, attr) => {
    const config = remappedConfigs[attr.type];
    if (config) {
      acc[attr.id] = {
        integration: attr,
        config,
      };
    }

    return acc;
  }, {});

  return {
    remappedIntegrations,
    isIntegrationsFetched,
  };
}

export function useLoadingProgress(statuses: boolean[]) {
  const totalFetchedItems = statuses.length;
  const progressPart = Math.ceil(100 / totalFetchedItems);
  const completedProgressCount = statuses.filter((fetched) => fetched).length;
  return Math.min(completedProgressCount * progressPart, 100);
}

export function useScrollToTop() {
  const { search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [search]);
}
